!(function () {
    "use strict";
    customElements.get("testimonials-slider") ||
        customElements.define(
            "testimonials-slider",
            class extends HTMLElement {
                constructor() {
                    super(), (this.flkty = null), (this.onResizeCallback = () => this.onResize());
                    this.onWindowLoadCallback = () => this.onWindowLoad();
                    this.initialCheckComplete = false;
                }
                connectedCallback() {
                    (this.container = this.closest('[data-section-type="testimonials"]')),
                        (this.slides = this.querySelectorAll("[data-item]")),
                      
                        this.listen();
                    
                    // Defer initial width check until window load event to ensure correct slide count and layout
        if (document.readyState === 'complete') {
          // Window already loaded, check immediately
          this.checkSlideCount();
          this.initialCheckComplete = true;
        } else {
          // Wait for window load event
          window.addEventListener('load', this.onWindowLoadCallback, {once: true});
        }
      }

      onWindowLoad() {
        if (!this.initialCheckComplete) {
          this.checkSlideCount();
          this.initialCheckComplete = true;
        }
                }
                onResize() {
                    this.checkSlideCount(),
                        null !== this.flkty &&
                            (this.flkty.resize(),
                            this.flkty.size.width >= this.flkty.slideableWidth && this.destroySlider());
                }
                checkSlideCount() {
                    const e = this.slides.length,
                        t = Boolean(2 == e && window.innerWidth >= theme.sizes.small),
                        i = Boolean(1 == e);
                    if (!t && !i)
                        return this.flkty
                            ? void (
                                  this.flkty &&
                                  (this.flkty.isActive || this.initSlider(),
                                  this.flkty.slideableWidth > this.flkty.size.width
                                      ? this.initSlider()
                                      : this.destroySlider())
                              )
                            : (this.initSlider(), void this.onResize());
                    this.destroySlider();
                }
                initSlider() {
                    (this.flkty = new window.theme.Flickity(this, {
                        cellSelector: "[data-item]",
                        prevNextButtons: !0,
                        pageDots: !0,
                        groupCells: !0,
                        cellAlign: this.dataset.sliderAlignment,
                        contain: !0,
                        adaptiveHeight: !1,
                        on: {
                            ready: () => {
                                this.slidesTabIndex(),
                                    requestAnimationFrame(() => {
                                        this.querySelectorAll(".flickity-button").forEach((e) => {
                                            window.theme.wrap(e, "flickity-button-holder");
                                        }),
                                            this.flkty && this.flkty.resize();
                                    });
                            },
                            change: () => {
                                this.slidesTabIndex();
                            },
                        },
                    })),
                        window.theme.isMobile()
                            ? this.container.classList.remove("has-arrows")
                            : this.container.classList.add("has-arrows"),
                        this.createResizeClass();
                }
                createResizeClass() {
                    if ("function" == typeof window.theme.Flickity.prototype._createResizeClass) return;
                    (window.theme.Flickity.prototype._createResizeClass = function () {
                        this.element.classList.add("carousel--resize");
                    }),
                        window.theme.Flickity.createMethods.push("_createResizeClass");
                    const e = window.theme.Flickity.prototype.resize;
                    window.theme.Flickity.prototype.resize = function () {
                        this.element.classList.remove("carousel--resize"),
                            e.call(this),
                            this.element.classList.add("carousel--resize");
                    };
                }
                slidesTabIndex() {
                    window.theme.Flickity.data(this).cells.forEach((e) => {
                        let t = "-1";
                        e.element.classList.contains("is-selected") && (t = "0"),
                            e.element.querySelectorAll("a, button").forEach((e) => {
                                e.setAttribute("tabindex", t);
                            });
                    });
                }
                destroySlider() {
                    this.classList.contains("flickity-enabled") &&
                        (null !== this.flkty &&
                            (this.querySelectorAll(".flickity-button")?.forEach((e) => {
                                const t = e.parentNode;
                                t &&
                                    t.classList.contains("flickity-button-holder") &&
                                    (t.parentNode.insertBefore(e, t), t.parentNode.removeChild(t));
                            }),
                            this.flkty.destroy()),
                        this.container.classList.remove("has-arrows"));
                }
                listen() {
                    document.addEventListener("theme:resize:width", this.onResizeCallback);
                }
                disconnectedCallback() {
                    document.removeEventListener("theme:resize:width", this.onResizeCallback);
                    window.removeEventListener('load', this.onWindowLoadCallback);
                }
            }
        );
})();
